import styled from "styled-components";
import { Switch } from "antd";

export default styled(Switch)`
    min-height: 0px;
    &.ant-switch-checked{
        background-color: #5FDBA7 !important;
    }

    .ant-switch-inner{
        font-size: 14px;
    }
`